import { useState } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchAgencyPublishers } from "../api/publisherService";
import { DEFAULT_PAGE_SIZE } from "../utils/constants";
export var usePublisherData = function (appliedFilters, buildQuery, pageSize) {
    var _a;
    if (pageSize === void 0) { pageSize = DEFAULT_PAGE_SIZE; }
    var ky = useOkapiKy();
    var _b = useState(0), pageOffset = _b[0], setPageOffset = _b[1];
    var _c = useState(0), totalRecords = _c[0], setTotalRecords = _c[1];
    var _d = useQuery(["publishers", appliedFilters, pageOffset, pageSize], function () {
        return fetchAgencyPublishers(ky, {
            query: buildQuery(appliedFilters),
            offset: pageOffset,
            limit: pageSize,
        });
    }, {
        keepPreviousData: true,
        enabled: true,
        onSuccess: function (data) {
            var _a;
            setTotalRecords((_a = data.totalRecords) !== null && _a !== void 0 ? _a : 0);
        },
    }), data = _d.data, isLoading = _d.isLoading, isError = _d.isError;
    var publishersData = (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [];
    var fetchMoreData = function (offset) {
        setPageOffset(offset);
    };
    var resetPageOffset = function () { return setPageOffset(0); };
    return {
        publishersData: publishersData,
        totalRecords: totalRecords,
        isLoading: isLoading,
        isError: isError,
        fetchMoreData: fetchMoreData,
        resetPageOffset: resetPageOffset,
        pageOffset: pageOffset,
        pageSize: pageSize,
    };
};
